import axios from "axios";
import { Message } from "element-ui";

export const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 100000,
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 响应失败
    if (res.code !== 200) {
      if (response.status !== 200) {
        Message({
          message: res.msg || "出错了",
          type: "error",
          duration: 5 * 1000,
        });
        return Promise.reject(response);
      } else {
        return res;
      }
    } else {
      // 响应成功
      return res;
    }
  },
  (error) => {
    Message({
      message: error.msg,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

// 导出get和post方法
export default {
  get: (url = "", params = {}) => {
    return new Promise(function (resolve, reject) {
      request
        .get(url, { params })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  post: (url = "", data = {}) => {
    return new Promise(function (resolve, reject) {
      request
        .post(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
